import {gsap} from "gsap";
import CustomProperty from "./Modules/CustomProperty.js";

CustomProperty();

const tl = gsap.timeline({paused: true});

const chars = document.getElementById('js-text').querySelectorAll('.js-char');
const frags = document.getElementById('js-text').querySelectorAll('.js-char > *');

frags.forEach((frag, j) => {
  gsap.set(frag, {
    xPercent: (Math.random() * 2 - 1) * 500,
    yPercent: (Math.random() * 2 - 1) * 500,
    rotationX:(Math.random() * 2 - 1) * 180,
    rotationY:(Math.random() * 2 - 1) * 180,
    opacity: 0,
  })
});

tl.to(frags, {
  duration: 0.6,
  xPercent: 0,
  yPercent: 0,
  rotationX: 0,
  rotationY: 0,
  opacity: 1,
  ease: 'none',
  stagger: {
    each: 0.001,
    ease: 'none',
  }
});

tl.play();